module.exports = {"content":{},"productInfo":{"code":"{12AB6794-19A5-4DF1-9027-A2C4C787AB9D}","name":"アラビア語　初中級","serialHead":"KPWRA","courseResourceIDs":[{"levelNo":1,"resourceID":"35e34aa1a1ebf50c393821cb13e731bc00ce3582"},{"levelNo":2,"resourceID":"f82e9c5e36c01091c4adb582c5a19a39db29c39b"},{"levelNo":3,"resourceID":"4d0ceb84441b9f3b4af4794fe90e28308201adf3"}],"language":"ar","challengeCount":22215},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1